module.exports = __webpack_public_path__ + "img/w3_share_black.478024ff.png";